import React from "react";
import ProjectSwitcher from "../../component/admin/ProjectSwitcher";

const SwitchProject = () => {
  const active = localStorage.getItem("activeProject") || "school";
  return (
    <div className="switch-project-page">
      <ProjectSwitcher activeProject={active} />
    </div>
  );
};

export default SwitchProject;
